// extracted by mini-css-extract-plugin
export default {"customer_layout":"CustomerLayout_customer_layout__q45v+","customer_layout_children":"CustomerLayout_customer_layout_children__f72c2"};